$color-rejected-status: #d4403a;
$color-incomplete-status: #495057;
$color-pending-status: #4488ff;
$color-approved-status: #0ead0e;
$color-table-border: #d0d0d0;
$color-table-border-mobile: #979797;
$color-white: #ffffff;
$color-table-heading: rgba(0, 0, 0, 0.5);
@import "../../variables.scss";

.timesheet__status {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 160px;
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.34px;
  line-height: 22px;
  text-align: center;
  border-radius: 21px;

  &__pending {
    border: 2px solid $color-pending-status;
    color: $color-pending-status;
    background-color: rgba(68, 136, 255, 0.05);
  }

  &__approved {
    border: 2px solid $color-approved-status;
    background-color: rgba(14, 173, 14, 0.05);
    color: $color-approved-status;
  }

  &__rejected {
    border: 2px solid $color-rejected-status;
    background-color: rgba(212, 64, 58, 0.1);
    color: $color-rejected-status;
  }

  &__incomplete {
    border: 2px solid $color-incomplete-status;
    background-color: rgba(73, 80, 87, 0.05);
    color: $color-incomplete-status;
  }

  &__new {
    border: 2px solid $color-incomplete-status;
    background-color: rgba(73, 80, 87, 0.05);
    color: $color-incomplete-status;
  }

  &_button {
    width: 180px;
  }
}

.rejected {
  background-color: $color-rejected-status;
}

.approved {
  background-color: $color-approved-status;
}

.incomplete {
  background-color: $color-incomplete-status;
}

.pending {
  background-color: $color-pending-status;
}

.new {
  background-color: $color-incomplete-status;
}

.table {
  width: 100%;

  th {
    text-transform: uppercase;
    padding-left: 1.5rem;
    color: $color-table-heading;
    font-size: 0.9rem;
    font-family: Lato;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.26px;
    line-height: 17px;
  }

  tr {
    border-top: 1px solid;
    border-color: $color-table-border;
  }

  thead > tr {
    border: none;
  }

  th,
  td {
    display: inline-block;
  }

  th:first-child,
  td:first-child,
  th:last-child,
  td:last-child {
    width: 20%;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 4%;
    padding: 0;
  }
  th:nth-child(3),
  td:nth-child(3) {
    width: 16%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  th:nth-child(4),
  td:nth-child(4) {
    width: 23%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  th:nth-child(5),
  td:nth-child(5) {
    width: 17%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  td {
    padding: 1rem 1rem 1rem 1.5rem;
  }

  td:first-child {
    color: $color-white;
    text-transform: uppercase;
    font-size: 1.2rem;
    padding-left: 0.5rem;
  }
}
.table,
.timesheetMobile {
  a {
    text-decoration: none;
  }

  img {
    padding-right: 0.5rem;
  }
}

.timesheetMobile {
  margin: 0 -15px 1rem -15px;
  display: flex;
  flex-direction: column;
  padding: 1rem;

  &:nth-child(even) {
    background-color: rgba(0, 30, 83, 0.05);
  }

  &__item {
    white-space: nowrap !important;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
